(() => {
  // Define the DOMParser instance only once
  const parser = new DOMParser();

  // Function to defer links (stylesheets)
  const deferLinks = (parsedHtml: any) => {
    const linkElement = document.querySelector('link[rel="stylesheet"]');
    if (linkElement) {
      let html =
        parsedHtml.documentElement.innerHTML ||
        parsedHtml.documentElement.textContent;

      if (html.includes('&lt;') || html.includes('&gt;')) {
        html = html.replace(/&lt;/gi, '<').replace(/&gt;/g, '>');
      }

      linkElement.insertAdjacentHTML('beforebegin', html);
    }
  };

  // Function to defer scripts
  const deferScripts = (parsedHtml: any) => {
    const head = document.head;
    const scriptElements: any[] = Array.from(parsedHtml.querySelectorAll('script'));

    scriptElements.forEach((script) => {
      const dtoScript = document.createElement('script');
      dtoScript.type = 'text/javascript';
      dtoScript.defer = true;
      dtoScript.async = true;
      dtoScript.src = script.src;
      head.appendChild(dtoScript);
    });
  };

  const deferredElements = document.querySelectorAll('noscript[defer]');

  deferredElements.forEach((deferredElement) => {
    const innerHtml = (deferredElement.innerHTML || '')
      .trim()
      .replace('\n', '');

    if (innerHtml === '') {
      return;
    }

    const html = innerHtml;
    const parsedHtml = parser.parseFromString(html, 'text/html');
    const deferType = (
      deferredElement.getAttribute('defer') || ''
    ).toLowerCase();

    switch (deferType) {
      case 'scripts':
        deferScripts(parsedHtml);
        break;

      case 'links':
      default:
        deferLinks(parsedHtml);
        break;
    }

    deferredElement.remove();
  });
})();
